/**
 * Translations for the live spectator interface.
 * Ported from livekyykka-mobiili/src/assets/translations.js
 */

export type Locale = 'fi-FI' | 'en-US';

export interface Translations {
  language: string;
  languageLong: string;
  appTitle: string;
  kyykka: string;
  tournamentOffice: string;
  homeTitle: string;
  manageMyTeams: string;
  description: string;
  searchLabel: string;
  yle: string;
  pro: string;
  frm: string;
  block: string;
  blocks: string;
  showGames: string;
  round: string;
  start_block: string;
  continuation_block: string;
  quarter_final: string;
  semi_final: string;
  bronze_game: string;
  final: string;
  team: string;
  field: string;
  scoreboard: string;
  games: string;
  allGames: string;
  gamesCount: string;
  gamesCountSingle: string;
  finishedGames: string;
  ongoingGames: string;
  upcomingGames: string;
  finishedNotFound: string;
  ongoingNotFound: string;
  upcomingNotFound: string;
  wins: string;
  ties: string;
  losses: string;
  mean: string;
  points: string;
  ongoingGame: string;
  teamSaved: string;
  teamRemoved: string;
  remove: string;
  myTeams: string;
  noSavedTeams: string;
  browseGames: string;
  nextGame: string;
  ifAdvancing: string;
  atTime: string;
  map: string;
  geolocationErrorType1: string;
  geolocationErrorType2: string;
  contentNotFound: string;
  newsListTitle: string;
  tournamentNotReadyTitle: string;
  restaurants: string;
  disqualified: string;
  cancelled: string;
  loading: string;
  error: string;
  notFound: string;
  // Game status translations
  gameStarted: string;
  firstHalfDone: string;
  secondHalfDone: string;
  overtime: string;
  // Block status translations
  advances: string;
  eliminated: string;
  gamesRemaining: string;
  waitingForResults: string;
  // Bracket view translations
  bracket: string;
  rounds: string;
  scrollHorizontally: string;
  estimate: string;
  live: string;
  // Pagination translations
  loadMoreFinished: string;
  showingFinished: string;
  // Team filter translations
  findTeam: string;
  searchTeamPlaceholder: string;
  showingPathFor: string;
  pathToFinals: string;
  finished: string;
  // Restaurant-related translations
  openingTimes: string;
  openingTimesCafe: string;
  openingTimesBistro: string;
  openingTimesLunch: string;
  coffee: string;
  tea: string;
  hotJuice: string;
  donut: string;
  glutFreeDonut: string;
  candyBag: string;
  grill: string;
  vendaceDish: string;
  sausagePotatoes: string;
  vegetarianDishes: string;
  pancake: string;
  rasberryDonut: string;
  baoBunTeriyaki: string;
  baoBunVoner: string;
  muchosNachos: string;
  fries: string;
  overTheTopFrenchFriesBacon: string;
  overTheTopFrenchFriesVoner: string;
  Linjasto: string;
  kauraPunajuuri: string;
  jauhelihaPullat: string;
  peaSoup: string;
  foodTicket: string;
  vegePeaSoup: string;
}

const fi: Translations = {
  language: 'FI',
  languageLong: 'Suomi',
  appTitle: 'Kyykkä-App',
  kyykka: 'Akateemisen kyykän MM-kilpailut',
  tournamentOffice: 'Kysymyksiä? Kisatoimisto on avoinna koko kyykkäpäivän ajan!',
  homeTitle: 'Etusivu',
  manageMyTeams: 'Hallinnoi omia joukkueita',
  description: 'Seuraa Akateemisen kyykän MM-kilpailujen tuloksia reaaliajassa!',
  searchLabel: 'Hae joukkuetta',
  yle: 'Yleinen sarja',
  pro: 'Prosarja',
  frm: 'Firma-sarja',
  block: 'Lohko',
  blocks: 'lohkoa',
  showGames: 'Näytä pelit',
  round: 'Kierros',
  start_block: 'Alkulohko',
  continuation_block: 'Jatkolohko',
  quarter_final: 'Puolivälierä',
  semi_final: 'Semifinaali',
  bronze_game: 'Pronssiottelu',
  final: 'Finaali',
  team: 'Joukkue',
  field: 'Kenttä',
  scoreboard: 'Lohkopisteet - kierros',
  games: 'Pelit',
  allGames: 'Kaikki pelit',
  gamesCount: 'peliä',
  gamesCountSingle: 'peli',
  finishedGames: 'Pelatut',
  ongoingGames: 'Käynnissä',
  upcomingGames: 'Tulevat',
  finishedNotFound: 'Ei pelattuja pelejä',
  ongoingNotFound: 'Ei käynnissä olevia pelejä',
  upcomingNotFound: 'Ei tulevia pelejä',
  wins: 'Voitot',
  ties: 'Tasan',
  losses: 'Häviöt',
  mean: 'KA',
  points: 'Pts',
  ongoingGame: 'Joukkue pelaa parhaillaan kentällä',
  teamSaved: 'Tallennettu omiin joukkueisiin',
  teamRemoved: 'Poistettu omista joukkueista',
  remove: 'Poista',
  myTeams: 'Omat joukkueet',
  noSavedTeams: 'Et ole vielä tallentanut joukkueita. Etsi ja lisää joukkueita haun kautta!',
  browseGames: 'Selaa sarjojen pelejä',
  nextGame: 'Seuraava peli kentällä',
  ifAdvancing: 'Jatkopaikalla kenttä',
  atTime: 'klo',
  map: 'Kartta',
  geolocationErrorType1: 'Sivustolla ei ole lupaa sijaintisi hakemiseen.',
  geolocationErrorType2: 'Sijaintisi hakemisessa tapahtui virhe.',
  contentNotFound: 'Hakemaasi sisältöä ei löytynyt.',
  newsListTitle: 'Ajankohtaista',
  tournamentNotReadyTitle: 'Turnauksen aikataulut tai joukkueet eivät ole ajan tasalla',
  restaurants: 'Ravintolat',
  disqualified: 'Joukkue hylätty',
  cancelled: 'Peruttu',
  loading: 'Ladataan...',
  error: 'Virhe',
  notFound: 'Ei löytynyt',
  // Game status translations
  gameStarted: 'Käynnissä',
  firstHalfDone: '1. pääty pelattu',
  secondHalfDone: '2. pääty pelattu',
  overtime: 'Jatkoaika',
  // Block status translations
  advances: 'Jatkoon!',
  eliminated: 'Ei jatkopaikkaa',
  gamesRemaining: 'peliä jäljellä',
  waitingForResults: 'Odottaa muita tuloksia',
  // Bracket view translations
  bracket: 'Turnauskaavio',
  rounds: 'kierrosta',
  scrollHorizontally: 'Vieritä vaakasuunnassa nähdäksesi kaikki kierrokset',
  estimate: 'arvio',
  live: 'LIVE',
  // Pagination translations
  loadMoreFinished: 'Lataa lisää päättyneitä pelejä',
  showingFinished: 'Näytetään {{shown}} / {{total}} päättynyttä peliä',
  // Team filter translations
  findTeam: 'Etsi joukkue',
  searchTeamPlaceholder: 'Kirjoita joukkueen nimi...',
  showingPathFor: 'Näytetään {{team}} reitti finaaliin',
  pathToFinals: 'reitti finaaliin',
  finished: 'Päättynyt',
  // Restaurant-related translations
  openingTimes: 'Aukioloajat',
  openingTimesCafe: 'Kahvila',
  openingTimesBistro: 'Anniskelu',
  openingTimesLunch: 'Lounas ja Street Food',
  coffee: 'Kahvi',
  tea: 'Tee',
  hotJuice: 'Kuuma mehu',
  donut: 'Munkki',
  glutFreeDonut: 'Gluteeniton munkki',
  candyBag: 'Sotilaskoti -karkkipussi',
  grill: 'grilli',
  vendaceDish: 'Muikkuannos',
  sausagePotatoes: 'Makkaraperunat',
  vegetarianDishes: 'Vegaaniannos, Falafel',
  pancake: 'Lätty',
  rasberryDonut: 'Vadelmamunkki',
  baoBunTeriyaki: 'Bao Bun nyhtöpossu-teriayki-täytteellä 2 kpl',
  baoBunVoner: 'Bao Bun vöner-täytteellä 2 kpl',
  muchosNachos: 'Nachot (lisänä salsa tai cheddarjuustokastike 1 €)',
  fries: 'Ranskalaiset',
  overTheTopFrenchFriesBacon: 'Loaded fries (rapeaa pekonia, cheddarjuustokastiketta ja marinoitua punasipulia)',
  overTheTopFrenchFriesVoner: 'Loaded fries (rapeaa vöner pekonia, aiolia ja marinoitua punasipulia)',
  Linjasto: 'Linjasto',
  kauraPunajuuri: 'Kaura-punajuuripyöryköitä ja lime-chiligurttia sekä Papas Arrugadas-perunoita',
  jauhelihaPullat: 'Jauhelihapyöryköitä ja pippurikastiketta sekä Papas Arrugadas-perunoita',
  peaSoup: 'Hernekeitto',
  foodTicket: 'Ruokalipukkeella',
  vegePeaSoup: 'Kasvishernekeitto',
};

const en: Translations = {
  language: 'EN',
  languageLong: 'English',
  appTitle: 'Kyykkä-App',
  kyykka: 'World Championships of Academic kyykkä',
  tournamentOffice: 'Questions? The tournament office is open all day during the tournament!',
  homeTitle: 'Live Scores',
  manageMyTeams: 'Manage my teams',
  description: 'Follow the scores of Academic World Championship of Kyykkä in real time!',
  searchLabel: 'Search for a team',
  yle: 'Open league',
  pro: 'Pro league',
  frm: 'Company league',
  block: 'Group',
  blocks: 'groups',
  showGames: 'Show games',
  round: 'Round',
  start_block: 'Group stage 1',
  continuation_block: 'Group stage 2',
  quarter_final: 'Quarterfinal',
  semi_final: 'Semifinal',
  bronze_game: 'Bronze game',
  final: 'Final',
  team: 'Team',
  field: 'Field',
  scoreboard: 'Group Scoreboard - round',
  games: 'Games',
  allGames: 'All games',
  gamesCount: 'games',
  gamesCountSingle: 'game',
  finishedGames: 'Finished',
  ongoingGames: 'Ongoing',
  upcomingGames: 'Scheduled',
  finishedNotFound: 'No finished games',
  ongoingNotFound: 'No ongoing games',
  upcomingNotFound: 'No scheduled games',
  wins: 'Wins',
  ties: 'Ties',
  losses: 'Losses',
  mean: 'Mean',
  points: 'Pts',
  ongoingGame: 'The team is playing now on field',
  teamSaved: 'Saved to your teams',
  teamRemoved: 'Removed from your teams',
  remove: 'Remove',
  myTeams: 'My Teams',
  noSavedTeams: "You haven't saved any teams yet. Try searching for a team and adding one!",
  browseGames: 'Browse games by leagues',
  nextGame: 'Next game on field',
  ifAdvancing: 'If advancing, field',
  atTime: 'at',
  map: 'Map',
  geolocationErrorType1: "The page doesn't have permission to get your location",
  geolocationErrorType2: 'An error occurred while getting your location.',
  contentNotFound: 'The content you were accessing was not found.',
  newsListTitle: 'Recent news',
  tournamentNotReadyTitle: 'Note! Tournament schedule is not up to date!',
  restaurants: 'Restaurants',
  disqualified: 'Team disqualified',
  cancelled: 'Cancelled',
  loading: 'Loading...',
  error: 'Error',
  notFound: 'Not found',
  // Game status translations
  gameStarted: 'In progress',
  firstHalfDone: '1st half done',
  secondHalfDone: '2nd half done',
  overtime: 'Overtime',
  // Block status translations
  advances: 'Advances!',
  eliminated: 'Eliminated',
  gamesRemaining: 'games remaining',
  waitingForResults: 'Waiting for other results',
  // Bracket view translations
  bracket: 'Tournament Bracket',
  rounds: 'rounds',
  scrollHorizontally: 'Scroll horizontally to see all rounds',
  estimate: 'estimate',
  live: 'LIVE',
  // Pagination translations
  loadMoreFinished: 'Load more finished games',
  showingFinished: 'Showing {{shown}} / {{total}} finished games',
  // Team filter translations
  findTeam: 'Find team',
  searchTeamPlaceholder: 'Type team name...',
  showingPathFor: "Showing {{team}}'s path to finals",
  pathToFinals: 'path to finals',
  finished: 'Finished',
  // Restaurant-related translations
  openingTimes: 'Opening hours',
  openingTimesCafe: 'Cafe',
  openingTimesBistro: 'Alcoholic Beverages',
  openingTimesLunch: 'Lunch and Street Food',
  coffee: 'Coffee',
  tea: 'Tea',
  hotJuice: 'Hot juice',
  donut: 'Donut',
  glutFreeDonut: 'Gluten-free donut',
  candyBag: 'Sotilaskoti candy bag',
  grill: 'grill',
  vendaceDish: 'Fried vendace & garlic sauce',
  sausagePotatoes: 'Potato and sausage hash',
  vegetarianDishes: 'Vegan dish, fried falafel and fries',
  pancake: 'Pancake',
  rasberryDonut: 'Raspberry Donut',
  baoBunTeriyaki: 'Bao Bun with pulled pork-teriyaki-filling 2 pcs',
  baoBunVoner: 'Bao Bun with vöner-filling 2 pcs',
  muchosNachos: 'Nachos (add salsa or cheddarsauce for 1 €)',
  fries: 'French Fries',
  overTheTopFrenchFriesBacon: 'Loaded fries (crispy bacon, cheddarsauce and marinated red onion)',
  overTheTopFrenchFriesVoner: 'Loaded fries (crispy vöner bacon, aioli and marinated red onion)',
  Linjasto: 'From the buffet-line',
  kauraPunajuuri: 'Oat-beetroot-balls with lime-chili-yogurt and Papas Arrugadas-potatoes',
  jauhelihaPullat: 'Meatballs with pepper sauce and Papas Arrugadas-potatoes',
  peaSoup: 'Pea soup',
  foodTicket: 'With a food ticket',
  vegePeaSoup: 'Vegan pea soup',
};

export const translations: Record<Locale, Translations> = {
  'fi-FI': fi,
  'en-US': en,
};

export const locales: Locale[] = ['fi-FI', 'en-US'];

export const localeNames = locales.map((key) => ({
  key,
  name: translations[key].language,
  nameLong: translations[key].languageLong,
}));

export const defaultLocale: Locale = 'fi-FI';

